import { render } from "./Unloading.vue?vue&type=template&id=01bc6d2a&scoped=true&lang=true"
import script from "./Unloading.vue?vue&type=script&lang=js"
export * from "./Unloading.vue?vue&type=script&lang=js"

import "./Unloading.vue?vue&type=style&index=0&id=01bc6d2a&lang=css&scoped=true"

import exportComponent from "C:\\laragon\\www\\icl-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01bc6d2a"]])

export default __exports__